// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { setPage } from "../../actions";
import { connect } from "react-redux";
// Styles imports
import './TokenAnalyzerWalletStatsUpgrade.css';
import '../../util.css'
// Svg icons import
import { ReactComponent as DirectUpSvg } from '../../svg-icons/arrow-up.svg';
// Consts imports
import { PAGE_UPGRADE } from "../../consts/consts";

function AvailableTitle() {
    return (
        <span className={"token-analyzer-upgrade-text"}>
            Upgrade your subscription<br/>to see other wallets.
        </span>
    );
}

class TokenAnalyzerWalletStatsUpgrade extends React.Component {

    constructor(props) {
        super(props);
    }

    handleUpgradeClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_UPGRADE);
    };

    render () {

        return (
            <div className={"token-analyzer-upgrade-item noselect"}>
                <div className={"token-analyzer-upgrade-item-block"} onClick={this.handleUpgradeClick}>
                    <DirectUpSvg className={"token-analyzer-upgrade-icon-direct-up"}/>
                    <AvailableTitle/>
                </div>
            </div>
        );
    }

}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setPage: setPage
    }, dispatch);
};

export default connect(null, mapDispatchToProps)(TokenAnalyzerWalletStatsUpgrade);